import * as React  from 'react';
import { useSelector } from 'react-redux';
import { MiddlePanelConstant } from "../../../containers/WorkkardDetail/constants";
import Icons from '../../../icons';
import { ActorAvatar, ActorName, useActor } from './actor';
import { combinedViewTime } from './dateKey';
import CombinedViewFiles from './combinedViewFiles';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';

/**
 * A note written against the Workkard.
 *
 * The note body, its privacy label, its attachments and its publish metadata
 * all arrive on the entry. There is no longer a /cvf request on mount to
 * discover whether the note has files.
 */
const WorkkardNote = (props) => {
    const sessionContext = useSelector(selectSessionContextOidc);
    const userView = sessionContext?.userView;
    const { data, isPrintPreview } = props;
    const note = data.note || {};
    const publisher = useActor(note.updated_by);

    const getDescription = () => {
        if (!process.env.mercury_orgIds.split(",").includes(String(sessionContext.organizationView.Id))) {
            return (
                `<section class='noteDescriptionFormating InformationLetter editorNoteFormatting'>${note.body}</section>`
            );
        }
        return note.body;
    };

    // "Private" and "Personal" are storage names; the timeline shows the labels
    // users recognise.
    const privacyLabel = note.privacy === 'Private' ? 'Internal'
        : note.privacy === 'Personal' ? 'Draft'
        : note.privacy;

    return (
        <div className="combinedListing detailListing">
            <div className="combinedCreatedDate detailCreatedDate">
                <ActorAvatar userId={data.actor_id} />
            </div>
            <div className="combinedRightBlock detailRightBlock resolutionChanged">
                <div className="combinedDescription detailDescription">
                    <div className="alignMiddle mb mb__8 flexWrap">
                        <div className="flexGrow alignMiddle">
                            <ActorName userId={data.actor_id} inner="header" />
                            <span className="dateTime mr">
                                <label className="mrNone">{combinedViewTime(data.occurred_at)}</label>
                            </span>
                            added a workkard note
                        </div>

                        <div className="cv_block_status">
                            <span className={`status right ${(privacyLabel || '').toLowerCase()}`}>
                                {privacyLabel}
                            </span>
                        </div>
                    </div>

                    <div className="update_information">
                        { note.internal_to_public && note.organization_id == userView?.orgId &&
                            <div className="publishNotesAdded alignMiddle">
                                <Icons name="public" className="icon mr" />
                                <label>{MiddlePanelConstant.Note.PublishedByText}
                                    <span className="mr black">{publisher.name}</span>
                                    from Internal to Public on {combinedViewTime(note.updated_date)}
                                </label>
                            </div> }
                        <div dangerouslySetInnerHTML={{__html: getDescription()}}></div>
                        <CombinedViewFiles files={data.files} entry={data} isPrintPreview={isPrintPreview} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WorkkardNote;
